import { motion } from "framer-motion";

const MASCOT = "https://customer-assets-jt897jd0.emergentagent.net/job_smoke-beach-drop/artifacts/g2ejgl6q_maskotka-obrys.webp";

export const Navbar = ({ t, lang, setLang, onSignup }) => (
  <motion.header
    data-testid="navbar"
    className="fixed left-1/2 top-4 z-50 w-[94%] max-w-6xl -translate-x-1/2"
    initial={{ y: -90, opacity: 0, rotate: -1 }}
    animate={{ y: 0, opacity: 1, rotate: -0.5 }}
    transition={{ delay: 0.4, duration: 0.8, ease: [0.34, 1.56, 0.64, 1] }}
  >
    <div className="toon-card flex items-center justify-between bg-[#f4f1ea] px-4 py-2.5 sm:px-6">
      <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
        <img src={MASCOT} alt="mascot" className="h-10 w-10 object-contain" />
        <span className="font-script text-2xl leading-none text-[#0a0a0a]">$IGN UP!</span>
      </a>
      <nav className="hidden items-center gap-8 font-mono2 text-[11px] font-bold tracking-[0.25em] text-[#0a0a0a]/70 md:flex">
        <a data-testid="nav-drop-link" href="#drop" className="transition-colors hover:text-[#d96b43]">{t.nav.drop}</a>
        <a data-testid="nav-lookbook-link" href="#lookbook" className="transition-colors hover:text-[#d96b43]">{t.nav.lookbook}</a>
        <a data-testid="nav-manifesto-link" href="#manifesto" className="transition-colors hover:text-[#d96b43]">{t.nav.manifesto}</a>
      </nav>
      <div className="flex items-center gap-3">
        <button
          data-testid="lang-toggle"
          onClick={() => setLang(lang === "pl" ? "en" : "pl")}
          className="btn-toon bg-[#e5b83b] px-3.5 py-1.5 text-sm text-[#0a0a0a]"
        >
          {lang === "pl" ? "EN" : "PL"}
        </button>
        <button
          data-testid="nav-signup-button"
          onClick={onSignup}
          className="btn-toon hidden bg-[#d96b43] px-5 py-1.5 text-base text-[#0a0a0a] sm:block"
        >
          {t.nav.signup}
        </button>
      </div>
    </div>
  </motion.header>
);
